/**
 * UserAvatar - Avatar component for user messages
 *
 * Displays the first letter of the user's name in a colored circle.
 * Shows full name on hover via tooltip.
 */

interface UserAvatarProps {
  name: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  showTooltip?: boolean
}

const sizeClasses = {
  sm: 'w-6 h-6 text-xs',
  md: 'w-8 h-8 text-sm',
  lg: 'w-12 h-12 text-lg',
  xl: 'w-16 h-16 text-2xl',
}

export function UserAvatar({
  name,
  size = 'md',
  className = '',
  showTooltip = true,
}: UserAvatarProps) {
  const initial = name?.charAt(0)?.toUpperCase() || '?'
  const displayName = name || 'Usuário'

  return (
    <div className="relative group">
      <div
        className={`${sizeClasses[size]} rounded-full bg-gray-600 dark:bg-gray-500 flex items-center justify-center flex-shrink-0 shadow-sm ${className}`}
        title={displayName}
      >
        <span className="font-semibold text-white">{initial}</span>
      </div>
      {/* Tooltip with full name on hover */}
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
          {displayName}
        </div>
      )}
    </div>
  )
}

export default UserAvatar
